"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTMLStripServiceInstance = void 0;
const client_1 = require("@rws-framework/client");
class HtmlStripService extends client_1.RWSService {
    /**
     * Strip all HTML tags from text content
     * @param text Text containing HTML tags
     * @returns Plain text without HTML
     */
    stripHtml(text) {
        if (!text || typeof text !== 'string') {
            return '';
        }
        // Create a temporary DOM element to leverage browser's HTML parsing
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = text;
        // Get text content which strips all HTML tags
        const stripped = tempDiv.textContent || tempDiv.innerText || '';
        // Clean up any remaining HTML entities
        return this.decodeHtmlEntities(stripped);
    }
    /**
     * Strip HTML from an array of messages
     * @param messages Array of message objects
     * @returns Array of messages with HTML stripped from content
     */
    stripHtmlFromMessages(messages) {
        if (!Array.isArray(messages)) {
            return [];
        }
        return messages.map(message => {
            if (message && typeof message === 'object') {
                const cleanMessage = { ...message };
                // Strip HTML from common message content fields
                if (cleanMessage.content) {
                    cleanMessage.content = this.stripHtml(cleanMessage.content);
                }
                if (cleanMessage.text) {
                    cleanMessage.text = this.stripHtml(cleanMessage.text);
                }
                if (cleanMessage.message) {
                    cleanMessage.message = this.stripHtml(cleanMessage.message);
                }
                return cleanMessage;
            }
            return message;
        });
    }
    /**
     * Sanitize assistant messages by stripping HTML and normalizing content
     * @param message Assistant message content
     * @returns Sanitized message content
     */
    sanitizeAssistantMessage(message) {
        if (!message || typeof message !== 'string') {
            return '';
        }
        // Strip HTML tags
        let sanitized = this.stripHtml(message);
        // Normalize whitespace
        sanitized = sanitized.replace(/\s+/g, ' ').trim();
        // Remove excessive line breaks
        sanitized = sanitized.replace(/\n{3,}/g, '\n\n');
        return sanitized;
    }
    /**
     * Decode HTML entities to their character equivalents
     * @param text Text containing HTML entities
     * @returns Text with decoded entities
     */
    decodeHtmlEntities(text) {
        const textArea = document.createElement('textarea');
        textArea.innerHTML = text;
        return textArea.value;
    }
    /**
     * Check if text contains HTML tags
     * @param text Text to check
     * @returns True if text contains HTML tags
     */
    containsHtml(text) {
        if (!text || typeof text !== 'string') {
            return false;
        }
        return /<[^>]*>/g.test(text);
    }
    /**
     * Remove specific HTML tags while preserving content
     * @param text Text containing HTML
     * @param tagsToRemove Array of tag names to remove (without brackets)
     * @returns Text with specified tags removed
     */
    removeSpecificTags(text, tagsToRemove) {
        if (!text || typeof text !== 'string' || !Array.isArray(tagsToRemove)) {
            return text;
        }
        let result = text;
        tagsToRemove.forEach(tag => {
            const regex = new RegExp(`<${tag}[^>]*>|</${tag}>`, 'gi');
            result = result.replace(regex, '');
        });
        return result;
    }
    /**
     * Clean text for context usage - strip HTML and normalize
     * @param text Text to clean
     * @returns Cleaned text suitable for context
     */
    cleanForContext(text) {
        if (!text || typeof text !== 'string') {
            return '';
        }
        // Strip HTML
        let cleaned = this.stripHtml(text);
        // Normalize whitespace and line breaks
        cleaned = cleaned.replace(/\r\n/g, '\n');
        cleaned = cleaned.replace(/\r/g, '\n');
        cleaned = cleaned.replace(/\t/g, ' ');
        cleaned = cleaned.replace(/ +/g, ' ');
        cleaned = cleaned.replace(/\n +/g, '\n');
        cleaned = cleaned.replace(/ +\n/g, '\n');
        cleaned = cleaned.replace(/\n{3,}/g, '\n\n');
        return cleaned.trim();
    }
}
exports.HTMLStripServiceInstance = HtmlStripService;
exports.default = HtmlStripService.getSingleton();
